exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vselect3[data-v-73119faa]{background:#fff;border-radius:20px;margin-right:15px;-webkit-box-shadow:0 2px 8px rgba(15,23,65,.08);box-shadow:0 2px 8px rgba(15,23,65,.08);height:40px;padding-left:10px;padding-right:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.vselect3 .vselect3_text[data-v-73119faa]{color:#999;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73119faa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Vselect2/index.vue
// module id = KMCX
// module chunks = 5